export default {
  common: {
    searchPlac: "搜索问题、话题或人",
    bottomTitle: "喷沫屋云AI工具",
    tip: "提示",
    sure: "确定",
    cancel: "取消",
    language: "语言",
    onlineService: "在线客服",
    del: "删除",
    edit: "编辑",
  },
  nav: {
    title: "喷沫屋AI",
    noNoTice: "没有未读通知",
    lookAll: "查看全部",
    login: "登录",
    register: "注册",
    set: "设置",
    logout: "退出",
    remainingPoints: "剩余积分",
    remainingArticles: "剩余篇数",
    recharge: "充值",
    index: "首页",
    mustRead: "站长必读",
    billingMethod: "计费方式",
    adminConsole: "管理控制台",
    notice: "通知"
  },
  sidebar: {
    title: "喷沫屋 管理控制台",
    adminConsole: "账户管理",
    recharge: "充值",
    webmanage: "站点管理",
    push: "接口文件相关",
    webkeywords: "栏目与关键词",
    aisetting: "生成发布设置",
    test: "手动运行测试",
    data: "文章暂存库",
    userWallet: "推荐返佣"
  },
  index: {
    topTitle: "通过关键词自动产出内容 自动发布",
    topSubTitle1:
      "基于调用OpenAI开发的ChatGpt大语言模型，按关键词生成相关文章，无需编写生成规则。目前支持GPT3.5以及GPT4.0",
    topSubTitle2:
      "自动生成高度匹配的原创内容，通过我们的内置算法，匹配最合适的SEO优化策略，智能定时定量输出高质量的SEO内容，让SEO事半功倍！",
    topSubBtn: "更多功能详解",
    topSubBtnTilte: "喷沫屋云AI工具 - 功能详解",
    apiKeyPlace: "请输入要ChatGpt3.5 的api Key",
    articleKey: "文章关键字",
    articleKeyPlace: "请输入要生成文章的关键字",
    btn: "立即生成文章",
    label1: "标题",
    label2: "关键词",
    label3: "TAG标签",
    label4: "内容简介",
    label5: "正文",
    title1: "丰富可选的SEO优化选项",
    title11:
      "系统内置业内主流SEO优化手段，包括组合标题、正文长度过滤、智能提取标签、关键词自动加粗、插入关键词、自动内链、自动配图、主动推送等。",
    title1Tag1: "AI标题",
    title1Tag2: "AI内容",
    title1Tag3: "自定义风格",
    title1Tag4: "智能标签",
    title1Tag5: "关键词加粗",
    title1Tag6: "插入关键词",
    title1Tag7: "自动内链",
    title1Tag8: "自动配图",
    title1Tag9: "主动推送",
    title2: "高度智能的AI系统",
    title21:
      "采用市面最强的OPENAI语言模型，可根据用户提供的关键词信息，通过互联网已有的内容，使用AI仿写标题，并根据标题来生成文章，内容高度原创，逻辑清晰，准确度高。用户可以通过自定义编辑生成规则，使文章更符合网站的内容要求，效果超越大部分人工编辑。",
    title22: "所以我们不只是一个生成器，更是一个功能强大的智能网编。",
    title2Tag1: "深度学习",
    title2Tag2: "语言模型",
    title2Tag3: "AI模型",
    title2Tag4: "高度可读",
    title2Tag5: "逻辑清晰",
    title3: "稳定可靠的自动运行生成任务",
    title31:
      "生成任务每天定时定量由服务器自动运行，无需看管，文章生成成功后自动推送到您的网站后台。",
    title32:
      "您只需要设置好必要的参数，就可实现全托管无人值守自动更新高质量文章。",
    title33: "更多功能请注册后体验。",
    title3Tag1: "自动生成",
    title3Tag2: "无需挂机",
    title3Tag3: "无人值守",
    title3Tag4: "自动发布",
    title4: "支持的内容管理系统、建站程序/平台",
    title5: "最新行业资讯"
  },
  mustRead: {
    all: "全部",
    keepRead: "继续阅读",
    publishedIn: "发表于",
    searchPlac: "搜索问题、话题或人",
    hotArticles: "热门文章",
    generatorRelated: "生成器相关"
  },
  billingMethod: {
    rule: "生成积分消耗规则",
    rule1: "联系客服可获取100积分+10篇推送额度用于测试。",
    rule2: "计费分为：token消耗积分计费、推送文章计费。",
    rule3:
      "积分消耗规则：使用您自己的api key 不会收取积分。如果您没有api key,那么使用我们官方的api key需要扣除消耗token对应的积分。",
    rule41: "token消耗积分计费：按照生成文章消耗的token扣除对应的积分。",
    rule42: "GPT3.5积分与token比例100:50000。",
    rule43: "GPT4.0积分与token比例100:1000。",
    rule44: "按照一篇文章大约500字，大概需要消耗1000-1300token，扣除积分如下：",
    rule45: "GPT3.5对应扣除积分2-2.6。",
    rule46: "GPT4.0对应扣除积分100-130。",
    rule5:
      "使用GPT4.0会额外扣除40积分每篇，这是因为需要支付接口调用次数的费用。",
    rule6:
      "在自定义前后缀提示词添加时，token消耗会增加，限制条件越多，消耗token越多。",
    rule7:
      "推送篇数：不发布到网站不扣除篇数。手动运行测试需要消耗一篇推送篇数。",
    rule8: "充值比例：1元=100积分。",
    rule9:
      "OpenAI的计费规则复杂，使用本平台积分转换可能会存在偏差，建议自行申请GPT3.5或者4.0的API key，这样更划算!"
  },
  adminConsole: {
    welcome: "欢迎您",
    changePassword: "修改密码",
    remainingArticles: "剩余篇数",
    rechargeArticles: "充值篇数",
    remainingPoints: "剩余积分",
    rechargePoints: "充值积分",
    details: "积分收支明细",
    time: "时间",
    consumePoints: "消耗积分",
    consumeArticles: "消耗篇数",
    type: "类型",
    info: "相关信息",
    more: "更多",
    noMore: "已无更多内容",
    website: "网站",
    jump: "跳转",
  },
  reset: {
    title: "修改密码",
    set: "用户设置",
    old: "当前密码",
    new: "新的密码",
    sure: "确认密码",
    submit: "提交",
    suc: "修改密码成功"
  },
  accountsetting: {
    title: "基本资料",
    account: "账号",
    realName: "真实姓名",
    contact: "联系方式",
    mobile: "手机号码",
    email: "常用邮箱",
    submit: "提交",
    suc: "修改信息成功"
  },
  verify: {
    title: "申请认证",
    currentState: "当前状态",
    notCertified: "未认证",
    authenticationType: "认证类型",
    personalAuthentication: "个人认证",
    institutionalAccreditation: "机构认证",
    realName: "真实姓名",
    identityCard: "身份证号码",
    contact: "联系方式",
    authDesc: "认证说明",
    accessories: "附件",
    clickUp: "点击上传",
    upTip: "请提交对应的身份证或者组织机构代码证件扫描",
    submit: "提交",
    suc: "修改信息成功"
  },
  login: {
    title: "账号密码登录",
    loginKey: "邮箱 / 用户名",
    passwd: "密码",
    btn: "登录",
    rememberMe: "记住我",
    retrievePassword: "找回密码"
  },
  addfunds: {
    title1: "选择充值金额（只针对没有API Key的用户，自有的不需购买）",
    integral: "积分",
    btn: "支付宝支付",
    title2: "选择托管套餐（无论有没有API Key都需要购买）",
    article: "篇文章",
    rmb: "元"
  },
  webmanage: {
    title: "站点管理",
    addWeb: "添加网站",
    batchAdd: "批量添加",
    webSearch: "站点搜索",
    orderNumber: "序号",
    web: "网站",
    record: "记录",
    consumeToken: "消耗Token",
    consumePoints: "消耗积分",
    bindingAPI: "绑定API",
    operate: "操作",
    openWeb: "点此打开网站首页",
    lookRecord: "点此查看生成记录",
    lookFinsh: "点此查看完成情况",
    pleaseBindAPI: "请绑定API",
    apiDown: "接口下载",
    columnSettings: "栏目设置",
    content: "内容设置",
    manualTest: "手动测试",
    articleMana: "文章管理",
    deletWeb: "删除网站",
    selectDel: "删除勾选",
    bindApiKey: "绑定api key",
    official: "官方",
    self: "自有",
    tipText: "免费版可能会限制调用频率",
    bindPlace: "请输入要绑定api key",
    delTip: "此操作将永久删除该网站, 是否继续?",
    hadDel: "已取消删除",
    delSuc: "删除成功",
    selectContent: "请选择内容",
    unbound: '未绑定',
  },
  addsite: {
    title: "添加网站",
    tip11: "请输入您的网站域名，若开启了",
    tip12: "，请选择",
    tip13: "协议头，否则请选择",
    tip14: "协议头。",
    eg: "如",
    tip21: "请将验证文件上传到",
    tip22: "网站根目录",
    tip23: "，并确认可以被正常访问，验证完后可以删除。",
    downFile: "下载验证文件",
    startVerify: "开始验证",
    submit: "提交",
    inputWeb: "请输入域名",
    verifySuc: "验证成功",
    addSuc: "添加成功",
    verifyTip1: "请验证域名所有权",
    verifyTip2: "无需验证，直接添加"
  },
  addsiteMore: {
    title: "批量添加网站",
    description: "格式说明",
    description1: "官方/key",
    description2:
      "|(栏目名称1;栏目ID;模式;关键词1,关键词2,关键词3;启动/停止)(栏目名称2;栏目ID2;模式;关键词1,关键词2,关键词3;启动/停止)(栏目名称3;栏目ID3;模式;关键词1,关键词2,关键词3;启动/停止)",
    divided: "分为",
    divided1: "域名",
    divided2: "GPT版本",
    divided3: "官方还是自有，自有需要填API KEY",
    divided4:
      "绑定栏目关键词以及生成模式：栏目名称随便填;对应栏目的ID;AI模式=1,自定义模式=2、关键词（以英文逗号分隔，可填写多个）",
    eg: "举例",
    eg1: "(新闻栏目;10;1;时事新闻,体育新闻;启动)",
    eg2: "(科技栏目;15;1;芯片,航天材料;停止)",
    eg3: "(军事新闻;13;2;南海局势,俄乌冲突;启动)",
    official: "官方",
    submit: "提交",
    verifyWeb: "验证网站",
    notVerifyWeb: "没有可验证的网站",
    verifyTip1: "请将验证文件上传到",
    verifyTip2: "网站根目录",
    verifyTip3: "，并确认可以被正常访问，验证完后可以删除。",
    verifyTip4: "(绿色表示验证通过)",
    downloadFile: "下载验证文件",
    validateWebsite: "开始验证",
    addWebiste: "添加通过的网站",
    verifySuc: "验证成功",
    addSuc: "添加成功"
  },
  push: {
    title: "获取推送接口文件",
    applicationDescription: "用途说明",
    applicationDescription1: "用于文章生成完毕后发布到您网站。",
    applicationDescription2: "请下载",
    applicationDescription3: "发布接口",
    applicationDescription4: "文件，上传到您网站",
    applicationDescription5: "根目录",
    applicationDescription6: "自动发布可能会被某些",
    applicationDescription7: "防火墙",
    applicationDescription8:
      "规则拦截，如果您的服务器开启了防火墙，建议添加URL白名单",
    applicationDescription9: "宝塔面板防火墙怎么添加URL白名单？",
    selectApi: "请选择您需要的接口",
    userName: "用户名",
    password: "密码",
    description: "说明",
    description1: "请填写您的",
    description2: "建站ABC后台",
    description3: "账号密码",
    subAdminLogin: "子管理员登录",
    save: "保存",
    apiDown: "发布接口下载",
    apiTest: "发布接口测试",
    selectApi: "请选择接口",
    selectWeb: "请选择网站",
    apiSuc: "发布接口测试成功",
    saveSuc: "保存成功"
  },
  webkeywords: {
    title: "栏目与关键词",
    addColumn: "添加栏目",
    batchAddColumns: "批量添加栏目",
    columnName: "栏目名称",
    limitTen: "最多10个字",
    columnId: "栏目ID",
    pushColumn: "要发布的目标栏目/分类ID",
    subColumnId: "子栏目ID",
    enterSubColumnId: "请输入子栏目ID",
    subColumnThree: "子栏目3",
    puhsTo: "推送到",
    article: "文章",
    product: "产品",
    cancel: "取消",
    save: "保存",
    aiMode: "AI模式",
    diyMode: "自定义模式",
    keyWord: "关键词",
    enterKeyWord: "请输入您的关键词，可点击预览效果",
    preview: "预览",
    previewTitle: "预览标题",
    wait: "预览标题可能需要30-60秒，请等待",
    diyAdd: "自定义模块（添加栏目）",
    mode: "模式",
    hadCreatArticles: "已生成文章数",
    operate: "操作",
    state: "状态",
    keyWordBind: "关键词绑定",
    delColumn: "删除栏目",
    enabled: "已启用",
    notEnabled: "未启用",
    enterTitle: "请输入标题",
    batchEnabled: "批量启用",
    batchNotEnabled: "批量停用",
    batchDel: "批量删除",
    commonProblem: "常见问题",
    problem1: "栏目名称和栏目ID怎么填？有什么影响？",
    problem11:
      "栏目名称只是方便用户区分不同栏目，只用于显示，不对生成行为产生任何影响。",
    problem12:
      "栏目ID用于发布时将文章发到对应的栏目下，所以需要通过接口文件发布的用户，一定要把栏目ID填对。",
    problem13:
      "栏目名称和栏目ID都允许重复添加，可通过此方式实现同一栏目使用多种关键词类型。",
    problem2: "WordPress栏目ID怎么看？",
    problem21: "在WordPress后台，在文章模块下找到分类菜单并打开。",
    problem22: "鼠标指向分类名称，查看浏览器左下角显示的链接，找到",
    problem23: "，所显示的数字就是此栏目的ID。",
    problem3: "为什么有的栏目生成到的文章很少？长期生成不到文章会怎么样？",
    problem31:
      "不同的关键词，网络上新增内容产生的速度不同。由于长期生成相同关键词，特别是关键词数量少、行业冷门、指定目标网站、过滤条件苛刻等条件下生成效率就会逐步下降。",
    problem32: "建议尽量多绑定关键词，对提升生成效率有明显效果。",
    problem4: "如何生成指定网站、指定关键词的内容？",
    problem41: "创建栏目时选择自定义模式，并绑定关键词。",
    problem42: "完成该网站的生成发布设置即可",
    problem5: "什么是AI模式？什么是自定义模式？",
    problem51:
      "AI模式：适合主关键词较少的行业，可以通过少量关键词拓展出相关长尾词生成大量文章",
    problem52:
      "自定义模式：输入的关键词即时文章标题。直接调用输入的关键词请求文章内容",
    diyBind: "自定义模块（关键词绑定）",
    addColumnSuc: "添加栏目成功",
    editColumnSuc: "编辑栏目成功",
    enabledTip: "此操作将永久停用该栏目, 是否继续?",
    noEnabledTip: "此操作将永久启用该栏目, 是否继续?",
    delTip: "此操作将永久删除该栏目, 是否继续?",
    hadCancelEnabled: "已取消停用",
    hadCancelNotEnabled: "已取消启用",
    hadCancelDel: "已取消删除",
    enabledSuc: "启用成功",
    notEnabledSuc: "停止成功",
    enterSaveKeyWord: "请输入要保存的关键词",
    saveSuc: "保存成功",
    enterKeyWord: "请输入关键词",
    selectContetn: "请选择内容"
  },
  massaddtype: {
    title: "批量添加栏目",
    description1:
      "格式说明：栏目名称|栏目id|模式(1:AI，2：自定义)|关键词1,关键词2,关键词3.....，如：",
    description2: "股票配资|10|1|股票配资哪家好,股票配资找XXX,股票配资专业机构",
    description3:
      "，每行一个。批量添加栏目后，请注意设置关键词，否则无法获取内容。",
    submit: "提交",
    addSuc: "批量添加栏目成功"
  },
  test: {
    title: "手动运行测试",
    btn: "开始",
    tip11: "请选择要测试的域名，点击",
    tip12: "按钮启动测试。大约需要30-60秒，请耐心等待",
    tip2: "手动生成运行中",
    tip31: "通过绑定关键词",
    tip32: "绑定栏目ID",
    tip33: "获取到标题",
    tip34: "生成关键词",
    tip35: "生成TAG标签",
    tip36: "内容描述",
    tip37: "正文内容",
    tip38: "发布状态",
    tip39: "点击查看",
    tip41: "注意：本页面是为生成",
    tip42: "测试",
    tip43: "而设计，有",
    tip44: "速度限制",
    tip45: "，如需快速生成，请开启",
    tip46: "云端自动运行",
    problem: "常见问题",
    problem1: "运行生成任务之前，哪些设置是必须的？",
    problem11: "验证网站所有权，把网站添加到平台。",
    problem12:
      "设置好对应网站的栏目，填写正确的栏目ID，每个栏目添加关键词，最好多个。",
    problem13: "在生成发布设置页面中完成设置，点击保存按钮。",
    proble2: "多久才能生成到文章？",
    proble21: "每个网站首次运行生成任务，需要等待",
    proble22: "1-2分钟",
    proble23: "不等才能生成到文章，后续运行任务会快一些。",
    proble24:
      "不同关键词内容丰富程度不同，尽量多添加关键词，可以提高生成效率。",
    proble3: "生成到文章后，如何发布文章内容到网站？",
    proble31:
      "如需自动发布到网站，请上传对应程序的接口文件，并把文章交付方式设为",
    proble32: "通过接口文件发布到我的网站后台",
    proble33: "如需手动获取文章，或需先编辑再发布，请把文章交付方式设为",
    proble34: "把文章放到文章暂存库",
    proble4: "如何开启生成任务？",
    proble41: "栏目与关键词",
    proble42: "页面，需要设置栏目的状态为已启用才可以进行自动生成",
    proble43: "生成发布设置",
    proble44: "页面设有自动运行生成开关，开启之后服务器即会自动运行生成任务。",
    pushSuc: "已发布成功",
    pushErr: "发布失败",
    pointsConsumption: "积分消耗",
    aiModel: "使用的模型",
  },
  data: {
    title: "文章暂存库",
    allStatus: "全部状态",
    toEdit: "待编辑",
    hadEdit: "已编辑",
    hadPush: "已发布",
    search: "查询",
    page: "本页",
    all: "全部",
    head: "标题",
    status: "状态",
    time: "时间",
    consumeToken: "消耗Token",
    consumePoints: "消耗积分",
    operate: "操作",
    del: "删除",
    push: "发布",
    selectDel: "请选择要删除的记录",
    delTip: "此操作将永久删除该文章, 是否继续?",
    delSuc: "删除成功",
    hadDel: "已取消删除",
    selectPush: "请选择要发布的记录",
    pushTip: "此操作将发布该文章, 是否继续?",
    pushSuc: "发布成功",
    pushErr: "已取消发布",
    AIModelVersion: "AI模型版本",
  },
  aisetting: {
    title: "生成发布设置",
    importTemplate: "从模板导入",
    saveTemplate: "存为模板",
    autorun: "云端自动运行",
    autorunTip1: "云端自动运行任务。",
    autorunTip2: "只要账户有积分，系统会按您设置的时间自动运行，即使您",
    autorunTip3: "电脑关机也不影响",
    runTime: "运行时间",
    runTimeTip1: "24小时运行(默认)",
    runTimeTip2: "指定时段运行",
    runTimeTip3: "请勾选需要运行的时间段",
    clock: "点",
    getArticle: "每小时获取文章数",
    getArticleTip1: "全站发布",
    getArticleTip2: "篇/小时，各栏目篇数随机。",
    getArticleTip3: "仅为最大量，并不保证一定能达到",
    getArticleTip4: "，通常可达1000篇每小时(每站)，",
    contentSyle: "自定义内容风格",
    contentSyleTip1: "默认模式",
    contentSyleTip2: "专业模式",
    contentSyleTip3: "自定义模式",
    contentSyleTip4: "默认模式:系统会根据关键词请求内容。",
    contentSyleTip5: "举例:以“XXXXX”为关键词生成一篇文章",
    contentSyleTip6:
      "专业模式:本站搜集了互联网上各个领域的内容生成方式，请选择与您网站内容有关的领域，使内容更精准。",
    contentSyleTip7: "前缀",
    contentSyleTip8: "后缀",
    contentSyleTip9: "自定义模式:您可以自定义输入提问的前后缀来请求内容",
    contentSyleTip10: "举例",
    contentSyleTip11: "你现在是一名专业的医生，你需要以医生的角度来帮我写作，",
    contentSyleTip12: "以“XXXX”为关键词生成一篇文章",
    contentSyleTip13: "，内容需要与癌症治疗相关。",
    contentSyleTip14: "红色为前缀，蓝色为后缀。",
    textLength: "正文长度选择",
    textLengthTip1:
      "请选择需求的正文长度（不一定能达到，取决于最终取决于AI的创作能力。）",
    textLengthTip2: "字左右",
    keyWordLimit: "单关键词生成文章限制",
    keyWordLimitTip1: "每个关键词最多允许生成",
    keyWordLimitTip2: "篇文章。",
    keyWordLimitTip3: " 如果留空或设为0，则不限篇数。（自定义模式留空即可）",
    author: "默认作者",
    authorTip1: "总是直接使用该作者，而不会从网页生成",
    article: "默认文章来源",
    relevance: "相关度优化",
    relevanceTip1: "正文随机位置自动插入当前关键词",
    relevanceTip2: "次。",
    relevanceTip3: "当正文中出现当前关键词时，自动把该关键词加粗。",
    relevanceTip4: "在正文开头插入文章标题。",
    relevanceTip5: "使用html标签：",
    relevanceTip6: "，不含",
    relevanceTip7: "，例如：",
    relevanceTip8: "，留空则不使用任何标签。",
    tags: "Tags标签",
    tagsTip1: "智能提取标签，数量",
    tagsTip2: "个",
    tagsTip3: "当前生成关键词作标签",
    tagsTip4: "不使用Tags标签",
    fixedLink: "固定链接",
    fixedLinkTip1: "为正文中",
    fixedLinkTip2: "已存在的",
    fixedLinkTip3: "词汇添加链接，每行一个，最多200个，格式：",
    fixedLinkTip4: "文章生成",
    fixedLinkTip5: "表示如果正文中出现",
    fixedLinkTip6: "文章生成",
    fixedLinkTip7: "这个词，则把它链接到",
    fixedLinkTip8: "如果某个词在正文中多次出现，只在第一次出现时添加链接。",
    fixedLinkTip9: "链接可以是站内或站外的，可以是首页或内页，但不要包含",
    fixedLinkTip10: "符号。",
    fixedLinkTip11: "固定链接，每行一个",
    keywordDensity: "关键词密度",
    keywordDensityTip1: "从以下关键词随机取",
    keywordDensityTip2: "个，插入到正文随机位置，为0则关闭。可以是单独的词语如",
    keywordDensityTip3: "文章生成",
    keywordDensityTip4: "，也可以是一段html，如",
    keywordDensityTip5: "文章生成",
    keywordDensityTip6: "，每行一个，最多1万个。",
    keywordDensityTip7: "需要插入的关键词，每行一个",
    autoImg: "自动配图",
    autoImgTip1: "每篇配图",
    autoImgTip2: "幅(最多5幅)",
    autoImgTip3:
      "请在下方填写图片网址，系统将在其中随机抽取图片，不再从网络获取。每行一个，最多2000个。",
    autoImgTip4: "自定义图片网址，每行一个，如：",
    autoImgTip5:
      "如果图片无法正常显示，可能原因是网络图片有防盗链设置，请尝试使用",
    autoImgTip6: "图片本地化",
    autoImgTip7: "或",
    autoImgTip8: "上传云存储",
    autoImgTip9: "解决。",
    imgAlt: "图片alt属性",
    imgAltTip1: "使用相关长尾词",
    imgAltTip2: "使用当前关键词（默认）",
    imgAltTip3: "使用文章标题",
    imgAltTip4: "空白alt属性",
    addStart: "文章开头添加内容",
    addStartTip1: "在",
    addStartTip2: "文章开头",
    addStartTip3: "添加一段内容，允许使用",
    addStartTip4: "标签，字数不超过500字符。",
    addStartTip5: "文章开头添加内容",
    addEnd: "文章末尾添加内容",
    addEndTip1: "在",
    addEndTip2: "文章末尾",
    addEndTip3: "追加一段内容，允许使用",
    addEndTip4: "标签，字数不超过500字符。",
    addEndTip5: "文章末尾添加内容",
    payType: "文章交付方式",
    payTypeTip1: "自动发布：通过",
    payTypeTip2: "接口文件",
    payTypeTip3: "发布到网站后台，发布失败时保存到",
    payTypeTip4: "文章暂存库",
    payTypeTip5: "，用于发布的接口文件请自行获取。",
    payTypeTip6: "手动发布：直接把文章放到",
    payTypeTip7: "文章暂存库",
    payTypeTip8: "，以便手动编辑再发布或复制到其他媒体，或批量下载到本地。",
    pushTime: "文章发布时间",
    pushTimeTip1: "生成完成立即发布",
    pushTimeTip2: "本时段内随机时间发布",
    pushTimeTip3: "（仅当开启自动发布时适用）",
    pushTimeTip4: "请勾选需要运行的时间段：",
    baiduPush: "百度主动推送",
    baiduPushTip1: "请填写百度资源平台推送接口密钥：",
    baiduPushTip2: "留空则关闭。",
    baiduPushTip3:
      "请同时将文章发布状态设为开放浏览，否则百度蜘蛛可能无法抓取。",
    byPush: "必应主动推送",
    byPushTip1: "请填写必应资源平台推送接口密钥：",
    byPushTip2: "留空则关闭。",
    byPushTip3: "请同时将文章发布状态设为开放浏览，否则必应蜘蛛可能无法抓取。",
    pushErr: "发布失败通知",
    pushErrTip1: "文章发布失败时，给我发送站内通知。",
    pseudoOriginal: "标题伪原创来源",
    pseudoOriginalTip1: "百度",
    saveSet: "保存设置",
    templateName: "模版名称",
    operate: "操作",
    import: "导入",
    del: "删除",
    close: "关闭",
    enterTemplateName: "请输入存为模板的名称",
    saveSuc: "保存成功",
    saveTemplateSuc: "保存模板成功",
    importSuc: "导入成功",
    delTip: "此操作将永久删除该模版, 是否继续?",
    hadCancelDel: "已取消删除",
    delSuc: "删除成功",
    imgMust: "图片为必选",
    titleSource: "标题来源",
    titleSourceTip1: "百度",
    titleSourceTip2: "谷歌",
    lang: "生成文章语言",
    langTip1: "中文",
    langTip2: "繁体",
    langTip3: "英文",
    googleSpiderPool: "谷歌蛛蛛池",
    googleSpiderPoolTip1: "是",
    googleSpiderPoolTip2: "否",
    googleSpiderPoolTip3: "提升收录",
    filterTitleType: "采集的标题过滤",
    filterTitleTypeTip1: "过滤纯英文",
    filterTitleTypeTip2: "过滤带中文",
    filterTitleTypeTip3: "不过滤",
    filterTitleTypeTip4: "仅限栏目",
    filterTitleTypeTip5: "标题中绑定AI模式",
    titleInsertKeyword: "标题插入关键词",
    titleInsertKeywordTip1: "插入开头",
    titleInsertKeywordTip2: "插入结尾",
    titleInsertKeywordTip3: "不插入",
    bindAi: "绑定AI版本",
    deductPoints: "本次扣除积分预览",
    pushWeb: "绑定的程序名",
    delimiter: "分隔符",
  },
  article: {
    pushTime: "发布时间",
    comment: "个评论",
    reply: "要回复文章请先",
    verify: "实名认证",
    promoter: "发起人",
    house: "喷沫屋",
    enterpriseCertification: "企业认证",
    ai: "云端的AI生成更轻松",
    popularArticles: "热门文章",
    generatorRelated: "生成器相关"
  },
  articleedit: {
    title: "文章标题",
    columnID: "栏目ID",
    articleContent: "文章内容",
    wysiwyg: "所见即所得编辑器",
    toolbar: "工具栏",
    code: "源码",
    bold: "加粗",
    incline: "倾斜",
    numberedList: "编号列表",
    itemList: "项目列表",
    blockReference: "块引用",
    editHyperlink: "编辑超链接",
    insertVideo: "插入视频",
    fullScreen: "全屏",
    press: "按",
    help: "获得帮助",
    save: "保存",
    savePush: "保存并发布",
    enterConter: "请输入文章内容",
    savePushSuc: "保存并发布成功",
    saveSuc: "保存成功",
    website: "所属网站",
    bindAi: "绑定AI版本",
    useProgram: "使用的程序",
  },
  forgotPassword: {
    title: "找回密码",
    email: "邮箱",
    next: "下一步",
    sucTip1: "邮件已发送",
    sucTip2: "密码重置链接已经发到您邮箱",
    sucTip3: "请登录您的邮箱并点击密码重置链接进行密码更改",
    sucTip4: "如果没有找到邮件，请尝试查看广告邮件、垃圾邮件等"
  },
  forgotPasswordTwo: {
    title: "找回密码",
    newPassword: "新密码",
    surePassword: "确认密码",
    sure: "确认保存",
    suc: "找回密码成功"
  },
  notice: {
    title: "通知",
    more: "更多",
  },
  signup: {
    title: "账号密码注册",
    account: "用户名",
    passwd: "密码",
    confirmPasswd: "重复密码",
    mobile: "手机号",
    email: "邮箱地址",
    btn: "注册",
    suc: "注册成功",
  },
  userWallet: {
    balance: "余额",
    withdrawal: "提现",
    copy: "复制",
    withdrawalUrl: " 推荐链接",
    referralEarning: "推荐收入",
    time: "时间",
    withdrawalAmount: "提现金额",
    withdrawalTime: "提现时间",
    enterAmount: "请输入提现金额",
    withdrawalList: "提现列表",
    conpySuc: "复制成功",
    reference: "推荐人",
    name: "姓名",
    account: "账号",
    recommendRate: "佣金比例",
  }
};



// WEBPACK FOOTER //
// ./src/lang/zh_CN.js